import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';

export class MainController {

  awesomeThings = [];

  /*@ngInject*/
  constructor($http, $scope) {
    this.$http = $http;
    this.$scope = $scope;
  }

  $onInit() {

    //Get list of projects
    this.$http.get('https://data.bayareametro.gov/resource/kgpp-qf8p.json')
      .then(response => {
        this.$scope.rowCollection = response.data;
        console.log(this.$scope.rowCollection);
      })
      .catch(err => {
        console.log(err);
      });

      //Get list of blueprint strategies
      this.$http.get('https://data.bayareametro.gov/resource/kgpp-qf8p.json?$select=blueprint_strategy&$group=blueprint_strategy&$order=blueprint_strategy')
      .then(response => {
        this.$scope.bpStrategies = response.data;
        console.log(this.$scope.bpStrategies);
      })
      .catch(err => {
        console.log(err);
      });

       //Get open period list
       this.$http.get('https://data.bayareametro.gov/resource/kgpp-qf8p.json?$select=open_period1&$group=open_period1&$order=open_period1')
       .then(response => {
         this.$scope.openPeriods = response.data;
         console.log(this.$scope.openPeriods);
       })
       .catch(err => {
         console.log(err);
       });

  }
}

export default angular.module('pba2050App.main', [uiRouter])
  .config(routing)
  .component('main', {
    template: require('./main.html'),
    controller: MainController
  })
  /** 
   * @desc Directive managing clear filters function
   */
   .directive("stResetSearch", function () {
    return {
      restrict: 'EA',
      require: '^stTable',
      link: function (scope, element, attrs, ctrl) {
        return element.bind('click', function () {
          return scope.$apply(function () {
            var tableState;
            tableState = ctrl.tableState();
            tableState.search.predicateObject = {};
            tableState.pagination.start = 0;
            return ctrl.pipe();
          });
        });
      }
    };
  })
  .directive("stFilteredCollection", function () {
    return {
      require: "^stTable",
      link: function (scope, element, attr, ctrl) {
        scope.$watch(ctrl.getFilteredCollection, function (val) {
          scope.filteredCollection = val;
        });
      },
    };
  })
  .directive('pageSelect', function() {
    return {
      restrict: 'E',
      template: '<input type="text" class="select-page" ng-model="inputPage" ng-change="selectPage(inputPage)">',
      link: function(scope, element, attrs) {
        scope.$watch('currentPage', function(c) {
          scope.inputPage = c;
        });
      }
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js